import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content border-radius" }
const _hoisted_2 = { class: "titre" }
const _hoisted_3 = { class: "items-container" }
const _hoisted_4 = { class: "nombre" }
const _hoisted_5 = { class: "texte" }
const _hoisted_6 = { class: "nombre" }
const _hoisted_7 = { class: "texte" }
const _hoisted_8 = { class: "nombre" }
const _hoisted_9 = { class: "texte" }
const _hoisted_10 = { class: "nombre" }
const _hoisted_11 = { class: "texte" }
const _hoisted_12 = { class: "nombre" }
const _hoisted_13 = { class: "texte" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('dashboard.fournisseur.factures.title', {dateDebut: _ctx.dateDebut, dateFin: _ctx.dateFin})) + " ", 1),
      _createVNode(_component_ReglePastille, { cle: "dashboardFournisseur.statutsFactures" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "a-valider border-radius item",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setFilterAValider && _ctx.setFilterAValider(...args)))
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getStatsFactures?.nbAValider), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.fournisseur.factures.avalider')), 1)
      ]),
      _createElementVNode("div", {
        class: "validees border-radius item",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setFilterValidees && _ctx.setFilterValidees(...args)))
      }, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getStatsFactures?.nbValidees), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('dashboard.fournisseur.factures.validees')), 1)
      ]),
      _createElementVNode("div", {
        class: "litige border-radius item",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setFilterLitige && _ctx.setFilterLitige(...args)))
      }, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.getStatsFactures?.nbLitige), 1),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('dashboard.fournisseur.factures.litige')), 1)
      ]),
      _createElementVNode("div", {
        class: "rejetees border-radius item",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setFilterRejetees && _ctx.setFilterRejetees(...args)))
      }, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getStatsFactures?.nbRejetees), 1),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('dashboard.fournisseur.factures.rejetees')), 1)
      ]),
      _createElementVNode("div", {
        class: "payees border-radius item",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setFilterPayees && _ctx.setFilterPayees(...args)))
      }, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getStatsFactures?.nbPayees), 1),
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.fournisseur.factures.payees')), 1)
      ])
    ])
  ]))
}